<template>
    <div class="tutorial-page">
      <h1>使用教程</h1>
      <div class="step" v-for="(step, index) in steps" :key="index">
        <h2>步骤 {{ index + 1 }}：{{ step.title }}</h2>
        <p>{{ step.description }}</p>
        <div v-if="step.image">
          <img :src="step.image" alt="步骤 {{ index + 1 }} 图片" />
        </div>
      </div>
      <div class="tips">
        <h2>使用小贴士</h2>
        <ul>
          <li>确保上传的PDF文件清晰、内容完整。</li>
          <li>若文件中有水印信息，可选择去除背景水印功能，输出文档更干净。</li>
          <li>转换前请确认PDF文件没有密码保护，以避免转换失败。</li>
          <li>转换完成后请检查文档格式，如有问题可尝试重新转换。</li>
        </ul>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "TutorialPage",
    data() {
      return {
        steps: [
          {
            title: "上传文件",
            description: "点击页面上的上传按钮，选择需要转换的PDF文件。确保文件完整且无密码保护。",
            image: "" // 如有步骤图片，可填写图片路径或URL
          },
          {
            title: "选择转换选项",
            description: "上传成功后，您可以选择是否去除背景水印以及其它可用的转换选项，以便获得更符合需求的输出文档。",
            image: ""
          },
          {
            title: "开始转换",
            description: "点击“转换”按钮，系统将自动处理文件，转换过程可能需要几秒钟，请耐心等待。",
            image: ""
          },
          {
            title: "下载文件",
            description: "转换完成后，点击下载按钮获取转换后的Word文档。下载后请检查格式与内容是否正确。",
            image: ""
          }
        ]
      }
    }
  }
  </script>
  
  <style scoped>
  .tutorial-page {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    font-family: Arial, sans-serif;
  }
  
  .tutorial-page h1 {
    text-align: center;
    margin-bottom: 30px;
  }
  
  .step {
    margin-bottom: 20px;
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
  }
  
  .step h2 {
    font-size: 1.5em;
    margin-bottom: 10px;
    color: #333;
  }
  
  .step p {
    font-size: 1em;
    line-height: 1.6;
    color: #666;
  }
  
  .step img {
    max-width: 100%;
    margin-top: 10px;
  }
  
  .tips {
    margin-top: 30px;
  }
  
  .tips h2 {
    font-size: 1.5em;
    margin-bottom: 10px;
    color: #333;
  }
  
  .tips ul {
    list-style-type: disc;
    margin-left: 20px;
    color: #666;
  }
  
  .tips li {
    margin-bottom: 5px;
  }
  </style>
  